/**
 * `squareSpace` — the square-grid realization of {@link Space}. A thin adapter:
 * every method delegates to the pure square primitives in `square.ts`, exactly as
 * `hexSpace` delegates to `coord`/`range`. The generic `aStar`/`reachable` (and
 * `reachableAnchors`/`canMoveTo`/`sight`/`visibility`) run on it unchanged.
 *
 * Pixel layout (cell→screen) is deliberately **not** here — it's a per-grid
 * render concern, off the rules-facing `Space`. The COMBAT.app renderer maps
 * `x*CELL` inline; a formal square layout only lands with token sprites.
 */
import { type Square, chebyshevDisk, diagonalFlanks, distance, equals, footprint, line, neighbors, parseSquareKey, square, squareKey } from "./square";
import { type Space, cellRegion } from "./space";

export const squareSpace: Space<Square> = {
  key: squareKey,
  parse: parseSquareKey,
  equals,
  distance,
  neighbors,
  diagonalFlanks,
  line,
  disk: (center, r) => cellRegion(chebyshevDisk(center, r), squareKey),
  footprint: (anchor, size) => cellRegion(footprint(anchor, size), squareKey),
  // Plain vector add: p + (to − from), in x/y.
  translate: (p, from, to) => square(p.x + (to.x - from.x), p.y + (to.y - from.y)),
};
